/** @jsx h */
import { h } from 'preact';
import { useEffect, useState } from 'preact/compat';
import Dialog from 'preact-material-components/Dialog';
import { connect } from 'react-redux';
import style from './style.css';
import SubmitButton from '../../../../submitButton';
import ConfirmCancelButton from '../../../../cancelTransactionButton/confirmCancelButton';
import CancellationReasonList from './cancellationReasonList';
import { apiStatus } from '../../../../../actionTypes';
import GenericLoader from '../../../../loader/GenericLoader';
import Utils from '../../../../../utils';
import BlockResult from '../../../../blockResult';
import { tracker, UserActionType } from '../../../../../tracking';
import { posCustomerPaymentFailureRoute } from '../../../../../alias/paymentRoutes';
import { route } from 'preact-router';
import { deviceType } from '../../../../../utils/deviceType';

const TransactionCancelBody = (props) => {
  const {
    pgData,
    returnUrl,
    apiState,
    pageKey,
    errorMessage,
    closeModal,
    metadata,
    channel,
    sourceRef,
  } = props || {};
  const utils = new Utils();

  const [cancellationReason, setCancellationReason] = useState('');

  useEffect(() => {
    tracker.trackUserInteraction(
      UserActionType.MODAL,
      'cancel_pop_up',
      pageKey,
      metadata,
    );
  }, []);

  const transactingDeviceType = Utils.getDeviceType(channel, sourceRef);
  const isPosTransaction =
    transactingDeviceType === deviceType.POS_MACHINE ||
    transactingDeviceType === deviceType.POS_USER_MOBILE;
  const message = () => {
    if (isPosTransaction) {
      return 'Transaction will be cancelled. You will have to re-initiate the transaction on the POS device to complete sale';
    } else if (pageKey === 'pv_payment_enter_mobile_mob') {
      return 'If you cancel the transaction, you will be taken back to the merchant website.';
    } else
      return (
        <CancellationReasonList
          setCancellationReason={setCancellationReason}
          pageKey={pageKey}
        />
      );
  };

  const submitReturnUrl = () => {
    if (
      channel &&
      ((channel === 'OFFLINE' && !sourceRef) || channel === 'PAYMENT_LINK')
    ) {
      route(`${posCustomerPaymentFailureRoute.path}`, true);
      closeModal();
      return;
    }
    utils.createAndSubmitDynamicForm(pgData, returnUrl, 0);
  };

  if (apiState === apiStatus.INITIATED) {
    return (
      <div className={style.loaderWrapper}>
        <GenericLoader loadingMsg='We are processing your transaction cancellation.' />
      </div>
    );
  } else if (apiState === apiStatus.SUCCESS) {
    return (
      <div className={style.successMessage}>
        <img src='https://iccdn.in/img/ic-cancel.svg' />
        <div className='font14 text-center text80'>Transaction cancelled.</div>
        <BlockResult
          visibilityTimeUntilRedirect={3}
          displayMessage='Returning in '
          buttonText='Return Now'
          submitFormCallback={submitReturnUrl}
        />
      </div>
    );
  } else if (apiState === apiStatus.ERROR) {
    return (
      <div className={style.loaderWrapper}>
        <img src='https://iccdn.in/img/ic-error.svg' />
        <div className='font14 text-center text80'>
          {errorMessage || 'Something Went wrong. Please try it in some time'}
        </div>
      </div>
    );
  }

  return (
    <div>
      <Dialog.Header>
        <div className='text-center bold-800 font20 text80 text-color'>
          Cancel Transaction?
        </div>
      </Dialog.Header>
      <Dialog.Body>
        <div className={`${style.bodyWrapper} font14 text80`}>{message()}</div>
      </Dialog.Body>
      <Dialog.Footer>
        <div className={style.buttonContainer}>
          {isPosTransaction ? (
            <div>
              {' '}
              <SubmitButton
                pageKey={pageKey}
                elementName='continue_transaction'
                buttonText='Continue with transaction'
                className={`${style.confirmCancellation} font14`}
                buttonOnClick={closeModal}
                trackClickEvent={false}
              />
              <ConfirmCancelButton
                pageKey={pageKey}
                metadata={metadata}
                cancellationReason={cancellationReason}
                isPosTransaction={isPosTransaction}
              />
            </div>
          ) : (
            <div>
              {' '}
              <div className={style.outerButtonContainer}>
                <ConfirmCancelButton
                  pageKey={pageKey}
                  metadata={metadata}
                  cancellationReason={cancellationReason}
                  isPosTransaction={isPosTransaction}
                />

                <SubmitButton
                  pageKey={pageKey}
                  elementName='continue_transaction'
                  buttonText='Continue with Purchase'
                  className={`${style.confirmCancellation} font14`}
                  buttonOnClick={closeModal}
                  trackClickEvent={false}
                />
              </div>
            </div>
          )}
        </div>
      </Dialog.Footer>
    </div>
  );
};

const mapStateToProps = ({
  config,
  modal,
  paymentUserData,
  paymentDetails,
}) => {
  const { pageKey, metadata, sourceRef } = config || {};
  const { channel } = paymentDetails || {};
  const { cancelTransaction } = modal || {};
  const { apiState, errorMessage } = cancelTransaction || {};
  const { pgData, returnUrl } = paymentUserData || {};
  return {
    pageKey,
    apiState,
    errorMessage,
    pgData,
    returnUrl,
    metadata,
    sourceRef,
    channel,
    paymentDetails,
  };
};
export default connect(mapStateToProps)(TransactionCancelBody);



// WEBPACK FOOTER //
// ./components/partial/layers/modals/cancelTransactionModal/transactionCancelBody.js